// FETCH ALL PROPERTIES FROM ACCESSORIES_INWARD DETAILS
export const FETCH_ACCESSORIES_INWARD_DETAILS_REQUEST_DK = 'FETCH_ACCESSORIES_INWARD_DETAILS_REQUEST_DK';
export const FETCH_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK = 'FETCH_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_ACCESSORIES_INWARD_DETAILS_FAILURE_DK = 'FETCH_ACCESSORIES_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM ACCESSORIES_INWARD DETAILS
export const FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_ACCESSORIES_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM ACCESSORIES_INWARD DETAILS BY ID
export const FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_REQUEST_DK = 'FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_FAILURE_DK = 'FETCH_ACCESSORIES_INWARD_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR ACCESSORIES_INWARD DETAILS
export const CREATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK = 'CREATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK';
export const CREATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK = 'CREATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK = 'CREATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_ACCESSORIES_INWARD_DETAILS_DK = 'CREATE_USER_FORM_ACCESSORIES_INWARD_DETAILS_DK';

// UPDATE PROPERTIES FOR ACCESSORIES_INWARD DETAILS
export const UPDATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK = 'UPDATE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK = 'UPDATE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE ACCESSORIES_INWARD_DETAILS
export const FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR ACCESSORIES_INWARD DETAILS
export const DELETE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK = 'DELETE_ACCESSORIES_INWARD_DETAILS_REQUEST_DK';
export const DELETE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK = 'DELETE_ACCESSORIES_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK = 'DELETE_ACCESSORIES_INWARD_DETAILS_FAILURE_DK';

// USERFORM RESET

export const ACCESSORIES_INWARD_DETAILS_USERFORM_RESET_DK = 'ACCESSORIES_INWARD_DETAILS_USERFORM_RESET_DK';


export const ACCESSORIES_INWARD_DETAILS_PO_DETAILS_DISABLED_DK = 'ACCESSORIES_INWARD_DETAILS_PO_DETAILS_DISABLED_DK';
